import { useState, useEffect } from "react";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { Button, Form } from "react-bootstrap";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import useAxios from "../../hooks/useAxios";

const MapRoleAndGroup = ({ groupId, loadGroups, hide }) => {
  const [userRoles, setUserRoles] = useState();
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [checkedRoles, setCheckedRoles] = useState({});
  const axiosInstance = useAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  // Function to handle checkbox change
  const handleCheckboxChange = (role) => {
    setCheckedRoles((prevCheckedRoles) => ({
      ...prevCheckedRoles,
      [role.name]: !prevCheckedRoles[role.name],
    }));
    
    // Check if the role ID is already in the state
    const isSelected = selectedRoleIds.includes(role.id);

    // If it's selected, remove it from the state; otherwise, add it
    setSelectedRoleIds((prevSelectedRoleIds) =>
      isSelected
        ? prevSelectedRoleIds.filter((id) => id !== role.id)
        : [...prevSelectedRoleIds, role.id]
    );
  };
  const mapRoleAndGroup = (e) => {
    e.preventDefault();
    let dataToSend = [];
    selectedRoleIds.forEach((roleId) => {
      dataToSend.push({
        groupId,
        roleId,
      });
    });
    axiosInstance({
      url: `/users/groups/${groupId}/roles`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.access_token}`,
      },
      data: dataToSend,
    })
      .then((res) => {
        if (res.status <= 200 && res.status <= 200) {
          loadGroups();
          toastSuccess("Group and role mapped successfully");
          hide();
          // setActiveStep(0);
        } else {
          toastError("Could not create user group");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchUserRoles = async () => {
    try {
      const response = await axiosInstance.get("/users/roles");
      setUserRoles(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchUserRoles();
  }, []);
  return (
    <div>
      <form onSubmit={mapRoleAndGroup}>
        <div className='d-flex flex-wrap mt-3' style={{ gap: 20 }}>
          {userRoles?.map((role) => (
            <Form.Check
              key={role.id}
              label={role.name}
              id={role.id}
              name='roles'
              checked={checkedRoles[role.name] || false}
              onChange={() => handleCheckboxChange(role)}
            />
          ))}
        </div>
        <div className='d-flex justify-content-center'>
          <Button className='custom-btn-color' type='submit'>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MapRoleAndGroup;
